import { ISnackbarState } from './interface/ISnackBarState'

export const initialSnackbarState: ISnackbarState = {
    title: '',
    message: '',
    snackBarState: 'unmount',
    timeTillUnmount: 0,
}
